import * as yup from 'yup'

export const validateUpdateEventSchedule = yup.object().shape({
    moderator: yup
    .string()
    .nullable(true)
    .min(2, 'El MODERADOR debe tener más de 2 caracteres'),
    date:yup
    .string()
    .min(1, 'La FECHA debe tener más de 1 caracteres'),
})
